const general_event = require('../../config/general_event');
const { excute_linux_command, recursiveAsyncReadLine } = require('../../action/common');
const get_main_disk_command = "df | grep ' /$' | awk '{print $1}'"

/**
 * Retrieves disk usage information for a specified directory or the main disk.
 * 
 * @async
 * @param {string} [dir] - The directory path to check for disk usage. If not provided, the main disk will be checked.
 * @returns {Promise<string>} A promise that resolves to the disk usage percentage.
 * @throws {Error} If the command execution fails.
 */
const get_disk_info = async (dir) => {
  if (!dir) dir = await excute_linux_command(get_main_disk_command);
  dir = dir.trim();
  var command = "df -h --output=pcent " + dir;
  const result = await excute_linux_command(command);
  const percent_str = result.split("\n")[1]
  const percent = percent_str ? percent_str.trim() : null;
  return { [`${dir}`]: percent };
}

let disk_monitor_instance = null;

/**
 * Starts the disk monitoring process at a specified interval.
 *
 * @async
 * @function disk_monitor_start
 * @param {number} [interval=10000] - The interval in milliseconds between disk usage checks.
 * @returns {Promise<void>} A promise that resolves when the disk monitor is started.
 */
const disk_monitor_start = (interval) => {
  if (check_disk_monitor_status()) return;
  if (!interval) interval = 10000;
  const interval_callback = async () => {
    const disk_info = await get_disk_info();
    general_event.emit("disk_monitor", disk_info);
  }
  interval_callback();
  disk_monitor_instance = setInterval(interval_callback, interval);
}

const disk_monitor_stop = () => {
  clearInterval(disk_monitor_instance);
  disk_monitor_instance = null;
}

const check_disk_monitor_status = () => {
  return disk_monitor_instance !== null;
}

if (require.main === module) {
  const help_message = `
  1. get_disk_info
  2. disk_monitor_start
  3. disk_monitor_stop
  4. check_disk_monitor_status
  `
  console.log(help_message);

  const disk_monitor_callback = (disk_info) => {
    console.log(disk_info);
  }
  recursiveAsyncReadLine(async (input) => {
    switch (input) {
      case "1":
        get_disk_info().then((result) => {
          console.log(result);
        }).catch((error) => {
          console.error(error);
        });
        break;
      case "2":
        disk_monitor_start();
        general_event.on("disk_monitor", disk_monitor_callback);
        break;
      case "3":
        general_event.off("disk_monitor", disk_monitor_callback);
        if (general_event.listenerCount("disk_monitor") === 0) disk_monitor_stop();
        break;
      case "4":
        console.log(check_disk_monitor_status());
        break;
      default:
        console.log(help_message);
        break;
    }
  });
}

module.exports = {
  get_disk_info,
  disk_monitor_start,
  disk_monitor_stop,
  check_disk_monitor_status
}
